import { useQuery } from '@tanstack/react-query';
import { QueryFilter } from '@/features/ChartControls';
import { fetchChartData } from '../api/fetchChartData';

type Props = {
    filter: QueryFilter;
};

export const useChartData = ({ filter }: Props) => {
    const {
        data: chartData,
        isLoading,
        isError,
    } = useQuery({
        queryKey: ['singleChartData', filter],
        queryFn: () => fetchChartData(filter),
        staleTime: 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });

    return {
        chartData,
        isLoading,
        isError,
    };
};
